<template>
  <view class="train-container">
    <QueryCard />
    <block wx:if="{{!isAliAndNotLogin}}">
      <Schedule mixinShowProp="{{mixinShowProp}}"/>
      <LoginCard wx:if="{{homePageData?.need_mandatory_login}}" />
      <Diamonds class="diamonds" diamondsConf="{{diamondsConf}}" bind:pageGoTo="pageGoTo" />
      <CouponBanner wx:if="{{gotCoupons}}" useTab/>
      <Ad config="{{adApllloConfig}}" />
    </block>
    <Service notices="{{notices}}" isJhAliMini="{{isJhAliMini}}"/>
    <Slogan />
  </view>
  <FallingPopup wx:if="{{gotCoupons}}" fallingConf="{{homePageFallingConf}}" />
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import store from '@/store'
  import usexStore from '@/config/usex/lib/store'
  import { addRavenPhoneAndUid } from '@/common/raven-init/init'
  import { trackEvent } from '@/common/track'
  import { to12306LoginPage, gotoPurchaseInformationPage } from '@/common/pageJump'
  import { innerRouter, pagePath } from '@/common/jump'
  import { homePageFallingConf } from '@/config/falling-popup'
  import { getStorage, setStorage } from '@/utils/storage'
  import {
    STORAGE_EDIT_CITY_INFO_FOR_ALIWEB,
  } from '@/utils/train-storage'
  import { sendEvent, watchEvent } from '@/utils'
  import onShowHandleMixins from '@/mixins/homeTabOnShowHandleMixins'
  import { goTo } from '@didi/webx-js'
  import { isDdPassengerH5 } from '@/common/constant'
  import { is } from '@didi/spring-base'

  createComponent({
    mixins: [onShowHandleMixins],
    created() {
      watchEvent('updateHomePage', () => this.initHomePageData())
    },
    ready(){
      // 业务整改
      if(this.isAliAndNotLogin) this.getCouponData()
    },
    data: {
      homePageFallingConf, // 首页天降配置
      gotCoupons: false,
    },
    computed: {
      ...store.mapState({
        token: 'user.token',
        userInfo: 'user.userInfo',
        homeApolloData: 'common.homeApolloData',
        homePageData: 'common.homePageData',
        homeLoginTipVisible: 'login12306.homeLoginTipVisible',
      }),
      ...store.mapGetters({
        isHomeLoginValidate: 'login12306.isHomeLoginValidate',
        isAliAndNotLogin: 'user.isAliAndNotLogin'
      }),
      isLogin() {
        return this.token || this.userInfo?.token
      },
      adApllloConfig() {
        return this.homeApolloData?.ad_config || []
      },
      isJhAliMini() {
        const { appid } = this.$mpxRoute.query || {}
        return ['121735', '2021004166617541'].includes(appid)
      },
      notices() {
        return [{
          title: '服务协议及个人信息处理规则',
          url: this.isJhAliMini ? 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2&bc_scene=flight_train&lang=zh-CN&bc_appid=121735' : 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2\u0026policy_id=50057907'
        }, {
         title: '证照信息',
          url: 'https://dpubstatic.udache.com/static/dpubimg/277c7aa4c784604b629a4bdb7dcfcacb/index.html'
        }]
      },
      diamondsConf() {
       
        return [
          {
            type: 'invite',
            text: '邀请得券',
            icon:
              'https://ut-static.udache.com/webx/sfc/RvSsEESF9Vgc5GsQnCB_X.png',
            hide: is('harmonyos') || this.isJhAliMini
          },
          {
            type: '12306',
            text: '12306',
            // cornerText: !this.isHomeLoginValidate && !this.homeLoginTipVisible ? '未登录' : '',
            icon:
              'https://dpubstatic.udache.com/static/dpubimg/2obtQf5iRA_iDuPrKJ7ne_ic-12306.png',
          },
          {
            type: 'order',
            text: '我的订单',
            icon:
              'https://ut-static.udache.com/webx/sfc/gdI5JtzocGU3BMbRganUP_22.png',
          },
          {
            type: 'contactCustomerService',
            text: '联系客服',
            icon:
              'https://ut-static.udache.com/webx/sfc/WkQap-DxD5m-ewCKtemSO_33.png',
          }
        ]
      },
    },
    methods: {
      ...store.mapActions({
        init12306LoginStatusAction: 'login12306.init12306LoginStatusAction',
        initHomePageData: 'common.initHomePageData',
        getCouponData: 'coupon.getCouponData'
      }),
      ...store.mapMutations({
        setUserAccountStatus:'login12306.setUserAccountStatus',
        setChangeOrderInfo: 'change.setChangeOrderInfo',
        changeSelectCityList: 'travel.changeSelectCityList',
        setTrainList: 'train.setTrainList',
      }),
      onShowHandle() {
        trackEvent('userteam_train_home_sw', 'UT-火车票-首页-展现')
        if(!this.gotCoupons) {
          this.gotCoupons = true
        }else {
          sendEvent('updateCoupon')
        }
        this.initHomePageData()
        // 初始化校验12306登录状态 用于首页展示相关内容
        this.setUserAccountStatus(true)
        this.init12306LoginStatusAction()
        // 兼容支付宝小程序环境跳转问题处理的城市选择逻辑
        this.reloadDefaultCity()
        this.setChangeOrderInfo({})
        // 当返回首页时，清除列表数据，防止下次跳转到列表页时带有上一次的数据
        this.setTrainList({})
      },
      reloadDefaultCity() {
        const params = getStorage(STORAGE_EDIT_CITY_INFO_FOR_ALIWEB)
        if(params) {
          this.changeSelectCityList(params)
          setStorage({
            key: STORAGE_EDIT_CITY_INFO_FOR_ALIWEB,
            data:null
          })
        }
      },
      pageGoTo({ type, detail }) {
        if (type === 'pageGoTo' && detail?.type) this.goPage(detail.type)
      },
      async goPage(type) {
        if (!this.isLogin) {
          await usexStore.dispatch('getToken', true).then((res) => {
            addRavenPhoneAndUid(res)
          })
          return
        }
        if (type === '12306') {
          trackEvent('userteam_train_home_mine_ck', 'UT-火车票-首页-我的-点击', {
            module: 'my_12306'
          })
          to12306LoginPage({
            isIndex: 'current'
          })
          return
        }
        if (type === 'contactCustomerService') {
          trackEvent('userteam_train_home_mine_ck', 'UT-火车票-首页-我的-点击', {
            module: 'cus_service'
          })
          const source = is('passenger')
          ? 'app_ddcx_gzalb_im'
          : is('weixin')
            ? 'xcx_ddcx_kjjuo_im'
            : is('alipay')
              ? 'zfbxcx_ddcx_eoaeo_im'
              : ''
          gotoPurchaseInformationPage({
            type: 'train',
            source
          })
          return
        }
        if (type === 'order') {
          trackEvent('userteam_train_home_mine_ck', 'UT-火车票-首页-我的-点击', {
            module: 'my_order'
          })
          innerRouter.push(pagePath().ORDERLIST)
          return
        }
        if (type === 'invite') {
          const dchn = isDdPassengerH5
            ? 'MengA3Y'
            : 'p/xW5Rp37'
          trackEvent('userteam_train_home_mine_ck', 'UT-火车票-首页-我的-点击', {
            module: 'invit_coupon'
          })
          goTo({ url: `https://v.didi.cn/${dchn}` })
          return
        }
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .train-container
    box-sizing border-box
    height auto
    padding 0 10px
    .diamonds
      margin 8px auto
</style>

<script  name="json">
  module.exports = {
    usingComponents: {
      'Slogan': '@/components/slogan',
      'Service': '@/components/home-service',
      'Ad': '../ad',
      'CouponBanner': '@/components/coupon/coupon-banner',
      'Diamonds': '../diamonds',
      'FallingPopup': '@/components/falling-popup',
      'LoginCard': '@/components/login-card',
      'QueryCard': '../query-card-train',
      'Schedule': '../schedule',
    }
  }
</script>